export const truncateFileName = (fileName: string, maxLength: number = 15): string => {
    return fileName.length > maxLength ? `...${fileName.slice(-(maxLength - 3))}` : fileName;
};

export const getRelativePath = (fullPath: string, projectName: string | null): string => {
    if (!fullPath) return '';
    if (!projectName) return fullPath;

    const projectIndex = fullPath.indexOf(projectName);
    if (projectIndex === -1) return fullPath;

    return fullPath.substring(projectIndex + projectName.length + 1);
};